import { render, staticRenderFns } from "./antecedents.vue?vue&type=template&id=4651de7a&"
import script from "./antecedents.vue?vue&type=script&lang=js&"
export * from "./antecedents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports